module.exports = __webpack_public_path__ + "static/media/add.f8ee039f.svg";